/* eslint-disable import/prefer-default-export */
export const optionsDashboard = (t) => [
    { key: 'dashboard', label: t('menu:Dashboard'), url: '/' },
];
